import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { orderBy } from 'lodash';

const Badge = styled.div`
    font-size: clamp(1.3rem, 0.833vw, 1.8rem); //1.6rem
    font-weight: ${({ theme }) => theme.fontWeights.black};
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        justify-content: flex-start;
    }
`;

const Wash = styled.span`
    display: inline-block;
    border-radius: 20px;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.black};
    text-transform: uppercase;
    background-color: ${({ theme, exterior, useWhiteBackground }) =>
        exterior
            ? theme.colors.text.black
            : useWhiteBackground
              ? theme.colors.primary.white
              : theme.colors.text.lightBlue};
    color: ${({ theme, exterior }) =>
        exterior ? theme.colors.text.lightBlue : theme.colors.text.black};

    > span {
        position: relative;
        top: 1px;
    }

    &:only-child {
        padding: 10px 35px 9px;
    }

    &:first-of-type:not(:only-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        padding: 10px 15px 10px 25px;
    }

    &:last-of-type:not(:only-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        padding: 10px 25px 10px 15px;
    }
`;

const getWashType = (product) => {
    if (product.cleaningCategories?.nodes.length) {
        // Ensure Interior is always first
        return orderBy(product.cleaningCategories.nodes, ['name'], ['desc']);
    }
    if (!product.productCategories?.nodes.length) {
        return null;
    }
    return product.productCategories.nodes;
};

const WashTypeBadge = ({
    product,
    useWhiteBackground = false,
    className = ''
}) => {
    const washType = getWashType(product);

    return washType ? (
        <Badge {...{ className }}>
            {washType.map((category) => (
                <Wash
                    {...{ useWhiteBackground }}
                    exterior={category.name === 'Exterior'}
                    key={category.id}
                >
                    <span>{category.name}</span>
                </Wash>
            ))}
        </Badge>
    ) : null;
};

WashTypeBadge.propTypes = {
    product: PropTypes.shape({
        productCategories: PropTypes.shape({
            nodes: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    id: PropTypes.string.isRequired
                })
            )
        }),
        cleaningCategories: PropTypes.shape({
            nodes: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    id: PropTypes.string.isRequired
                })
            )
        })
    }).isRequired,
    useWhiteBackground: PropTypes.bool
};

export default WashTypeBadge;
